module.exports = __webpack_public_path__ + "static/media/ic_badge.ad20a3e4.png";